import { Tooltip as RadixTooltip } from "radix-ui"

import { cn } from "@/shared/lib/utils"

const TooltipProvider = RadixTooltip.Provider
TooltipProvider.displayName = "Tooltip.Provider"

const Tooltip = RadixTooltip.Root

const TooltipTrigger = RadixTooltip.Trigger
TooltipTrigger.displayName = "Tooltip.Trigger"

interface TooltipContentProps extends React.ComponentProps<typeof RadixTooltip.Content> {}

const TooltipContent: React.FC<TooltipContentProps> = ({ className, sideOffset = 4, ...props }) => (
  <RadixTooltip.Content
    {...props}
    sideOffset={sideOffset}
    className={cn(
      "z-[1000] overflow-hidden rounded-md border border-gray-700 bg-gray-800 px-3 py-1.5 text-sm text-gray-200 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    )}
  />
)
TooltipContent.displayName = "Tooltip.Content"

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
